window.Blimp = window.Blimp || {};

class Group extends Backbone.Model {
}

Blimp.Group = Group;